import { AppElement, AppFC } from '../../../interfaces';
import { IconProps } from './alertIcons/types';

export const ArrowIcon: AppFC<IconProps> = (props): AppElement => (
  <svg className="w-full h-full" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.957031 5.15674H14.0225V6.84226H0.957031V5.15674Z" fill="currentColor" />
    <path d="M10.3955 11.6476L9.21484 10.467L13.683 5.99994L9.21484 1.53287L10.3955 0.352295L16.0427 5.99996L10.3955 11.6476Z" fill="currentColor" />
  </svg>
);
